import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { loadSiteConfig } from './config/siteConfig';
import { hydrateGradePaletteFromSite } from './store/gradePaletteStore';
import { appCacheName, DEFAULT_GENERATION } from './Utils/offlineCache';

async function boot() {
  await loadSiteConfig();
  hydrateGradePaletteFromSite();
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

boot();

if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      // Remove legacy CRA service-worker.js (old builds / datawarehouse leftovers)
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(
        regs.map(async (reg) => {
          const scriptUrl =
            reg.active?.scriptURL ||
            reg.waiting?.scriptURL ||
            reg.installing?.scriptURL ||
            '';
          if (scriptUrl.includes('service-worker.js')) {
            await reg.unregister();
          }
        })
      );

      // App lives under /react-build; models live at /models — need root scope.
      // Requires Service-Worker-Allowed: / on sw.js (public/web.config).
      const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
      const swUrl = `${base}/sw.js`;
      const reg = await navigator.serviceWorker.register(swUrl, { scope: '/' });
      console.log('[SW] registered', { swUrl, scope: reg.scope });

      // Seed the document URL so offline launches do not hit DNS (ERR_NAME_NOT_RESOLVED).
      if ('caches' in window) {
        const cache = await caches.open(appCacheName(DEFAULT_GENERATION));
        const pageUrl = `${window.location.origin}${window.location.pathname}`;
        const shellUrls = [`${base}/`, `${base}/index.html`, pageUrl];
        await Promise.all(
          [...new Set(shellUrls.filter(Boolean))].map(async (url) => {
            try {
              const res = await fetch(url, { credentials: 'same-origin', cache: 'reload' });
              if (res.ok) await cache.put(url, res.clone());
            } catch {
              /* already offline */
            }
          })
        );
      }
    } catch (err) {
      // Common on self-signed / mismatched IIS certs — Cache Storage still used from the page
      console.warn('[SW] registration skipped:', err?.message || err);
    }
  });
}

reportWebVitals();
